'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/* date format used for client/server and server/client communication */
ngModule.constant("$serverDateFormat", "YYYY-MM-DD HH:mm:ss");
ngModule.constant("$serverShortDateFormat", "YYYY-MM-DD");

/* regexp matching the server date format */
ngModule.constant("$serverDateFormatRegexp", /^[0-9]{4}-[0-9]{2}-[0-9]{2}[ ][0-9]{2}:[0-9]{2}:[0-9]{2}$/);

/* adds the date interceptor to http interceptors */
ngModule.config(function ($httpProvider) {
  $httpProvider.interceptors.push('dateParserInterceptor');
});

/**
 * Date converter used by the interceptor and other 'to server' serializers.
 */
ngModule.factory("$dateConverter", function ($serverDateFormat, $serverDateFormatRegexp) {
  var serverDateFormatLength = $serverDateFormat.length;

  /**
   * Retu of original the object, recursively converting all string matching the $serverDateFormatRegexp to date object using the $serverDateFormat.
   */
  function parseObject(obj) {
    var keys = _.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i],
        value = obj[key];
      if (_.isString(value) && value.length === serverDateFormatLength && $serverDateFormatRegexp.test(value)) {
        obj[key] = moment(value, $serverDateFormat).toDate();
      } else if (_.isObject(value)) {
        parseObject(value);
      }
    }
    return obj;
  }

  /**
   * Returns a clone of the object, recursively converting all dates to strings using the $serverDateFormat
   */
  function formatObject(obj) {
    if (!_.isObject(obj)) {
      return obj;
    }
    var clone = _.extend({}, obj);
    _.each(clone, function (value, key) {
      if (_.isDate(value)) {
        clone[key] = moment(value).format($serverDateFormat);
      } else if (_.isArray(value)) {
        clone[key] = [];
        _.each(value, function (item, i) {
          clone[key][i] = formatObject(item);
        });
      } else if (_.isObject(value)) {
        clone[key] = formatObject(value);
      }
    });
    return clone;
  }
  return {
    parseObject: parseObject,
    formatObject: formatObject
  };
});

/* interceptor used to serialize dates when sending data to the server and parsing them when retrieving data */
ngModule.factory("dateParserInterceptor", function ($dateConverter) {
  var parseResponseDates = function parseResponseDates(obj) {
    return $dateConverter.parseObject(obj);
  };
  var formatRequestDates = function formatRequestDates(obj) {
    return $dateConverter.formatObject(obj);
  };
  return {
    request: function request(_request) {
      if (_.isArray(_request.data)) {
        _request.data = _.map(_request.data, function (el) {
          return formatRequestDates(el);
        });
      } else if (_.isObject(_request.data)) {
        _request.data = formatRequestDates(_request.data);
      }
      if (_.isObject(_request.params)) {
        _request.params = formatRequestDates(_request.params);
      }
      return _request;
    },
    response: function response(_response) {
      var doNotParse = _response.config && _response.config.noDateParsing === true;
      if (_.isObject(_response.data) && !doNotParse) {
        _response.data = parseResponseDates(_response.data);
      }
      return _response;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/http/dateParserInterceptor.js
// module id = 2711
// module chunks = 13